import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitionMatchesPageLinkParams} from "./competition.matches-page.link-params";

export class CompetitionMatchesPageLinkModel extends BaseLinkModel  {
  constructor(competitionId, sportName, competitionName, page, hashParams, isFollow: Boolean = true) {
    super(PAGES.COMPETITION.matches, new CompetitionMatchesPageLinkParams(competitionId, sportName, competitionName, page), false, null, null, hashParams);

    this.isFollow = isFollow;
  }
}